import './console-error-normalized';

/**
 * Re-export normalizeError from core to ensure single source of truth.
 * Core version handles both JS and TS contexts.
 */
export { normalizeError } from '@korvo/core/lib/normalize-error';